<template>
  <div class="dashboard-container">
    <div class="scroll-container"
         ref="tableContainer"
         @mouseenter="stopAutoScroll"
         @mouseleave="startAutoScroll"
         style="height: 390px">
      <div v-for="(item, index) in updata.tableData"
           :key="index"
           class="data-row sc_frame">
        <!-- 左侧内容 -->
        <div class="left-section">
          <div class="main-info sc_frame">
            {{ item.mainText }}
          </div>
          <div class="sub-info sc_frame"
               :style="{ color: clrSubInfo }">
            {{ item.subText }}
          </div>
        </div>

        <!-- 右侧内容 -->
        <div class="right-section">
          <div class="date-info sc_frame">
            {{ item.date }}
          </div>
          <div class="time-info sc_frame">
            {{ item.time }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    clrSubInfo: {
      type: String,
      default: '#FFD800' // '#00d8ff',
    },
    updata: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      chartTable: null // 表指针
    }
  },
  mounted() {
    this.chartTable = this.$refs.tableContainer
    this.startAutoScroll()
  },
  beforeUnmount() {
    this.stopAutoScroll()
  },
  methods: {
    startAutoScroll() {
      this.scrollInterval = setInterval(() => {
        if (this.chartTable === null) {
          console.log(typeof this.chartTable)
          return
        }

        if (
          this.chartTable.scrollTop + this.chartTable.clientHeight <
          this.chartTable.scrollHeight
        ) {
          this.chartTable.scrollTop += 1 // 调整数值控制速度（正数为向下，负数为向上）
        } else {
          this.chartTable.scrollTop = 0 // 到达底部后重置到顶部
        }
      }, 1000) // 调整间隔时间控制速度
    },
    stopAutoScroll() {
      clearInterval(this.scrollInterval)
    }
  }
}
</script>

<style scoped>
.sc_frame {
  border: 0px solid #969696;
  box-sizing: border-box; /* 确保内边距和边框不会影响宽度计算 */
}

.dashboard-container {
  display: flex;
  flex-direction: column;
  background: transparent;
}

.scroll-container {
  flex-grow: 0;
  flex-shrink: 0;
  /* flex: 0 0 471px; */
  overflow-y: auto;
  /* overflow: hidden; */
  /*scrollbar-width: 10px;  Firefox */
  /* scrollbar-color: rgba(0, 138, 251, 0.5) transparent; Firefox */
  transition: all 0.3s ease; /* 平滑滚动效果 */
}

/* 隐藏滚动条 */
.scroll-container::-webkit-scrollbar {
  display: none;
}

.data-row {
  display: flex;
  height: 64px;
  align-items: center;
  background: transparent;
  border: 0px solid #969696;
}
.data-row:nth-child(odd) {
  background: linear-gradient(90deg, rgba(42, 176, 248, 0.265), rgba(255, 255, 255, 0));
}

.data-row:nth-child(even) {
  background: linear-gradient(90deg, rgba(7, 7, 45, 0.635), rgba(255, 255, 255, 0));
}

.left-section,
.right-section {
  display: flex;
  height: 100%;
  flex-direction: column;
  /*justify-content: space-around;*/
}

.left-section {
  flex: 1;
  min-width: 60%;
  margin-left: 16px;
  gap: 2px;
}

.right-section {
  flex: 0 0 75px;
  text-align: left;
  margin-right: 16px;
  gap: 5px;
}

.main-info {
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  align-content: flex-end;
  height: 50%;
}
.sub-info {
  font-weight: 400;
  font-size: 16px;
  /* color: #00d8ff; */
  align-content: flex-start;
  height: 50%;
}
.date-info,
.time-info {
  white-space: nowrap;
  font-weight: 400;
  font-size: 14px;
  color: #95d8ff;
  height: 50%;
}
.date-info {
  align-content: flex-end;
}
</style>